import React from "react";

import {EMAIL} from "../constants";

const Parser = require('html-react-parser');

export default function NotFound() {
  return (
    <div className="errorWrapper">
      <div className="errorContent">
        <h1 className="headingPrimary">404</h1>
        <h2 className="headingSecondary">{__("Page not found")}</h2>
        <p className="paragraphStyle">
          {__("Unfortunately, the requested page could not be found. Please check if you entered the URL correctly and if you have an internet connection consists.")}
        </p>
        <p className="paragraphStyle">
          {__("Information about our products can be found at")} <a
          href="http://www.media4care.de">www.media4care.de</a>.
        </p>
        <p className="paragraphStyle">
          {Parser(__("If you have questions we can help you under %phone% or by E-mail continue to %email%!")
            .replace('%phone%', `<a href="tel:+498005750750">0800 / 5 750 750</a>`)
            .replace('%email%', `<a href="mailto:${EMAIL}">${EMAIL}</a>`))
          }
        </p>
        <p className="paragraphStyleButton">
          <a className="buttonPrimary"
             href="https://familie.media4care.com">{__("To the family portal")}</a>
        </p>
      </div>
    </div>
  );
}
